export const PREDICTOR_NAMES = {
    fplreview: "FPLReview",
    solioanalytics: "SolioAnalytics",
    fantasyfootballpundit: "FFPundit",
    fantasyfootballfix: "FFFix",
    fplteam: "FPLTeam",
    whatthefpl: "WhatTheFPL",
    fplgameweek: "FPLGameweek",
    drafthound: "DraftHound",
    fantalens: "FantaLens",
    fplcopilot: "FPLCopilot",
    fplform: "FPLForm",
    fplprophet: "FPLProphet",
    plfantasytool: "PLFantasyTool",
    smartplay: "SmartPlay",
    squadsignal: "SquadSignal",
    benchmark: "Benchmark",
};

export const PREDICTOR_COLORS = {
    fplreview: "#07b1bb",
    solioanalytics: "#f56074",
    fantasyfootballpundit: "#a6c02e",
    fantasyfootballfix: "#ffb355",
    fplteam: "#7e57c2",
    whatthefpl: "#26a69a",
    fplgameweek: "#ef5350",
    drafthound: "#5c6bc0",
    fantalens: "#ec407a",
    fplcopilot: "#8d6e63",
    fplform: "#29b6f6",
    fplprophet: "#ffca28",
    plfantasytool: "#66bb6a",
    smartplay: "#ab47bc",
    benchmark: "#888888",
};

